module.exports = __webpack_public_path__ + "static/media/carroussel_06.074fe39e.jpg";